/**
 * Notification Store Hook
 *
 * Simple hook for using the notification store
 * Follows project patterns
 */

import {useNotificationStore as useNotificationStoreZustand} from '../store/notificationStore';
import {Notification} from '../../../Services/common/NotificationTypes';

export const useNotificationStore = () => {
  const store = useNotificationStoreZustand();

  return {
    notifications: store.notifications,
    addNotification: store.addNotification,
    removeNotification: store.removeNotification,
    clearNotifications: store.clearNotifications
  };
};
